// extracted by mini-css-extract-plugin
export default {"wrapper":"Observer_wrapper__HY1UV","loader":"Observer_loader__zlyFC","observer":"Observer_observer__y9D-R"};